module.exports = __webpack_public_path__ + "static/media/masterCard.eb37e346.svg";